import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output } from '@angular/core';
import { ALLOWED_KEY_CODES } from './allowed-key-codes.constant';

@Component({
  selector: 'app-input-with-counter',
  template: require('./input-with-counter.component.html'),
  styles: [require('./input-with-counter.component.less')]
})

export class InputWithCounterComponent implements OnInit, OnChanges {
  @Input() qaAttr: string;
  @Input() value: string;
  @Input() maxCount: number;
  @Input() disabled: boolean;
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();
  public charsLeft: number;

  ngOnInit() {
    this.charsLeft = this.maxCount;
  }

  ngOnChanges(changes: SimpleChanges) {
    const { value } = changes;

    if (value && value.currentValue) {
      this.updateCounter();
    }
  }

  public blockTypingIfLimitReached(event): void {
    const { keyCode, which, target: { value } } = event;
    const keyPressed = keyCode ? keyCode : which;

    this.copyAndTruncateBusinessSemNameFrom(value);

    if (this.isValid(value) && !this.isKeyActionAllowed(keyPressed)) {
      event.preventDefault();
    }
  }

  public onChange(): void {
    this.updateCounter();
    this.valueChanged.emit(this.value);
  }

  private copyAndTruncateBusinessSemNameFrom(value: string): void {
    this.value = value.substring(0, this.maxCount);
  }

  private isKeyActionAllowed(keyCode: number): boolean {
    return ALLOWED_KEY_CODES.indexOf(keyCode) !== -1;
  }

  private updateCounter() {
    this.charsLeft = this.maxCount - this.value.length;
  }

  private isValid(value: string): boolean {
    return value.length >= this.maxCount;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/input-with-counter/input-with-counter.component.ts